import { useEffect, useState } from 'react';
import getAddresses from 'api/getAddresses';
import ChecklistTypes from '../constants/checklistTypes';

const useChecklists = () => {
	const [openNewChecklist, setOpenNewChecklist] = useState(false);
	const [checklistType, setChecklistType] = useState(ChecklistTypes.Patrol);
	const [customerID, setCustomerID] = useState('');
	const [addressID, setAddressID] = useState('');
	const [addresses, setAddresses] = useState([]);
	const [searchInput, setSearchInput] = useState('');

	useEffect(() => {
		(async () => {
			try {
				let _addresses = [];
				setAddresses([]);
				setAddressID('');
				setOpenNewChecklist(false);
				if (customerID) {
					_addresses = await getAddresses(customerID);
					setAddresses(_addresses);
				}
			} catch (error) {
				console.log('USE_USER_MGT ERROR :>> ', error);
			}
		})();
	}, [customerID]);

	const onClickNewChecklist = () => {
		setOpenNewChecklist(!openNewChecklist);
	};

	const checkDisableAddChecklist = () => {
		if (customerID === '0') {
			return false;
		}
		if (customerID === '' || addressID === '') {
			return true;
		}
		return false;
	};
	return {
		openNewChecklist,
		checklistType,
		setChecklistType,
		customerID,
		setCustomerID,
		onClickNewChecklist,
		addressID,
		setAddressID,
		addresses,
		checkDisableAddChecklist,
		searchInput,
		setSearchInput,
	};
};

export default useChecklists;
